import { ColumnDef } from '@tanstack/react-table';

import { AmendmentStatus } from '@xemplo/amendment-status';
import { AssignToCell, TotalAmountCell } from '@xemplo/amendments-table';
import { DisplayDateFormat, formatDate } from '@xemplo/date-time';
import { AmendmentListItem } from '@xemplo/gp-types';
import { getRequestedByUserName } from '@xemplo/gp-utils';

export const columns: ColumnDef<AmendmentListItem>[] = [
  {
    id: 'assignTo',
    accessorKey: 'assignTo',
    header: 'Worker',
    cell: AssignToCell,
    size: 260,
    enableSorting: false,
  },
  {
    id: 'amendmentTaskTypeName',
    accessorKey: 'amendmentTaskTypeName',
    header: 'Type',
  },
  {
    id: 'subType',
    accessorKey: 'amendmentSubTypeName',
    header: 'Sub type',
    enableSorting: false,
    cell: ({ row }) =>
      row.original.amendmentSubTypeName ? row.original.amendmentSubTypeName : '-',
  },
  {
    id: 'requested',
    accessorKey: 'requestedDate',
    header: 'Created',
    cell: ({ row }) =>
      formatDate({
        value: row.original.requestedDate,
        format: DisplayDateFormat.Medium,
      }),
    enableSorting: false,
  },
  {
    id: 'requestedBy',
    accessorKey: 'requestedBy',
    header: 'Requested',
    cell: ({ row }) => getRequestedByUserName(row.original.requestedBy),
    enableSorting: false,
  },
  {
    //TODO: Update this once BE returns value https://expedo.atlassian.net/browse/GC-870
    // Re-enable sorting and accessorFn once BE returns the value
    id: 'totalAmount',
    header: 'Total Amount',
    cell: TotalAmountCell,
  },
  {
    id: 'status',
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const amendmentStatusId = row.original.amendmentStatusId;
      return (
        <AmendmentStatus
          status={amendmentStatusId}
          statusName={row.original.amendmentStatusName ?? ''}
        />
      );
    },
    enableSorting: false,
  },
];
